import { DataSet } from "vis-data";
import { TimelineGroupType } from "../timeline";

export const useTimelineGroups = (
  dataset: DataSet<any>,
  groups: DataSet<any>
) => {
  const updateTimelineGroups = (
    parentGroup: TimelineGroupType,
    isExpanded: boolean
  ): void => {
    if (!parentGroup?.nestedGroups?.length) return;

    const items = dataset.get({
      filter: (item) => item.parentGroup === parentGroup.id,
    });

    items.forEach((item) => {
      dataset.update({
        id: item.id,
        group: isExpanded ? item.subgroup : item.parentGroup,
      });
    });
  };

  const toggleSavedItemsVisibility = (showSavedOnly: boolean) => {
    groups.forEach((group) => {
      const updatedGroup = {
        id: group.id,
        visible: group.canSave && showSavedOnly ? !!group.isSaved : true,
      };
      groups.update(updatedGroup);
    });
  };

  return { updateTimelineGroups, toggleSavedItemsVisibility };
};
